module.exports = "<app-base-reaction\r\n    *ngIf=\"enableSetting\"\r\n    [reactIndex]=\"reactIndex\"\r\n    [disabled]=\"disabled\"\r\n    (_onReact)=\"changeReact($event)\"\r\n></app-base-reaction>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/chat/chat-reaction/chat-reaction.component.html
// module id = ./src/app/commons/chat/chat-reaction/chat-reaction.component.html
// module chunks = main